import React from 'react';
import Icon from '../../../components/AppIcon';

const AssignmentPanel = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'John Smith',
      role: 'Environmental Compliance Officer',
      activeTasks: 3,
      completedThisMonth: 12,
      availability: 'available',
      avatar: 'JS'
    },
    {
      id: 2,
      name: 'Sarah Johnson',
      role: 'Safety Manager',
      activeTasks: 2,
      completedThisMonth: 15,
      availability: 'busy',
      avatar: 'SJ'
    },
    {
      id: 3,
      name: 'Michael Brown',
      role: 'Compliance Coordinator',
      activeTasks: 4,
      completedThisMonth: 10,
      availability: 'available',
      avatar: 'MB'
    },
    {
      id: 4,
      name: 'Emily Davis',
      role: 'Operations Manager',
      activeTasks: 1,
      completedThisMonth: 8,
      availability: 'available',
      avatar: 'ED'
    }
  ];

  const getAvailabilityConfig = (status) => {
    switch (status) {
      case 'available':
        return { color: 'bg-green-500', label: 'Available' };
      case 'busy':
        return { color: 'bg-orange-500', label: 'Busy' };
      default:
        return { color: 'bg-gray-500', label: 'Unavailable' };
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Team Assignment</h3>
          <p className="text-sm text-muted-foreground">Task allocation and workload</p>
        </div>
        <Icon name="Users" size={20} color="var(--color-muted-foreground)" />
      </div>

      <div className="space-y-4">
        {teamMembers?.map((member) => {
          const availConfig = getAvailabilityConfig(member?.availability);
          
          return (
            <div
              key={member?.id}
              className="p-4 bg-muted/50 rounded-lg hover:bg-muted transition-colors cursor-pointer"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="relative">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-sm font-semibold text-primary">
                    {member?.avatar}
                  </div>
                  <div className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 ${availConfig?.color} rounded-full border-2 border-card`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-medium text-foreground mb-0.5">{member?.name}</h4>
                  <p className="text-xs text-muted-foreground mb-2">{member?.role}</p>
                  <div className="flex items-center gap-2 text-xs">
                    <span className={`px-2 py-0.5 rounded ${availConfig?.color} text-white`}>
                      {availConfig?.label}
                    </span>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 pt-3 border-t border-border">
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Active Tasks</p>
                  <p className="text-lg font-semibold text-foreground">{member?.activeTasks}</p>
                </div>
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Completed</p>
                  <p className="text-lg font-semibold text-foreground">{member?.completedThisMonth}</p>
                </div>
              </div>

              <button className="w-full mt-3 inline-flex items-center justify-center gap-2 px-3 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors text-sm">
                <Icon name="UserPlus" size={14} />
                Assign Task
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AssignmentPanel;